// src/pages/usa/colorado/Vail.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Vail ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function Vail() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__vailBackRouteSet) {
      window.__vailBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Vail, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>⛷️ Discover Vail, Colorado</h2>

            <p>
              There’s a lot to say about Vail. It’s famous for snowboarding and
              skiing during the winter season, but in the summer, it transforms
              into a haven for hiking, mountain biking, and outdoor festivals.
              The town itself is charming, with a European alpine village
              vibe—cobblestone streets, boutique shops, and a wide variety of
              dining options. It’s definitely one of my favorite places to visit
              in Colorado, and one that should be on your list if you're
              planning a trip here. Vail is very walkable and has a free bus
              system that takes you around town and to the ski lifts. The two
              gondolas—Vail Village and Lionshead—are open during the summer
              months and offer stunning views of the surrounding mountains. The
              ride isn’t free, but it’s worth the price. As of now, you can
              still visit both gondolas with a single ticket.
            </p>

            {/* GETTING THERE */}
            <h3>🚗 Getting There</h3>

            <p>
              The drive from Denver to Vail is approximately 2 hours. I’m using
              Denver as the main reference point since most visitors fly into
              Denver International Airport (DEN) when coming to Colorado. Vail
              is located about 100 miles west of Denver via I‑70 W, and the
              drive itself is scenic—especially in spring and fall.
            </p>

            {/* PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Eagle Nest Gondola:</strong> The lift takes you from
                  Vail Village to the top of the mountain. Depending on the
                  season, you can enjoy panoramic views, hiking trails, and
                  dining at the Eagle's Nest restaurant. At the top you can also
                  take a short hike to the top of Vail Mountain. Eagle Nest has
                  roller coaster and zip line rides for the adventurous. All the
                  attractions are open during the summer months. During the
                  winter months, the gondola is used to access the ski slopes.
                  It doesn’t matter what time of year you visit—spring, summer,
                  fall, or winter—the views in Vail are always spectacular.
                </div>
              </li>
            </ul>

            {/* HIDDEN GEMS */}
            <h3>🥾 Other Hidden Gems</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Booth Falls Trail:</strong> A scenic 4‑mile hike through
                  aspens and alpine terrain, ending at a stunning waterfall.<br />
                  <a
                    href="https://www.google.com/maps?q=39.650717168200394, -106.320881071373"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Booth Falls Trailhead
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Piney Lake:</strong> A peaceful spot for canoeing,
                  hiking, and photography—especially beautiful in late spring.<br />
                  <a
                    href="https://www.google.com/maps?q=39.720353611432145, -106.39970405348464"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Piney Lake
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Betty Ford Alpine Gardens:</strong> The highest
                  botanical garden in North America.<br />
                  <a
                    href="https://www.google.com/maps?q=39.63997259716524, -106.3663255800064"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Betty Ford Alpine Gardens
                  </a>
                </div>
              </li>

             

              <li>
                <div className="place-block">
                  <strong>Gore Creek Path:</strong> A relaxing walk or bike ride
                  along the creek.<br />
                  <a
                    href="https://www.google.com/maps?q=39.627675572310736, -106.27477615945415"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Gore Creek Path
                  </a>
                </div>
              </li>
            </ul>

            {/* PLACES TO STAY */}
            <h3>🛏️ Places to Stay</h3>

            <p>
              I stayed at <strong>Marriott’s StreamSide Douglas at Vail</strong>{" "}
              during the spring and highly recommend it. The rooms were clean,
              the customer service was excellent, and it’s conveniently located
              close to town. They offer a free shuttle to Vail Village and the
              gondolas.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>The Sebastian – Vail:</strong> Boutique luxury with a
                  spa and heated pool.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Gravity Haus Vail:</strong> Cozy, modern, and steps from
                  Gondola One.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Four Seasons Resort Vail:</strong> High‑end comfort with
                  mountain views.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Evergreen Lodge:</strong> Budget‑friendly and centrally
                  located.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Antlers at Vail:</strong> Riverside condos with full
                  kitchens and balconies.
                </div>
              </li>
            </ul>

            {/* AFFILIATE BLOCK */}
            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>

            {/* VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I took from the Town. Be sure the quality is
              set to 1080p or higher.
            </p>

            <p>
              <a
                href="https://youtu.be/rj9Xp1-ygTA?si=ohZGszJHMpNdGUFp"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vail Mountain During Winter
              </a>
              <br />
              <a
                href="https://youtu.be/Mdt93i6mTBU?si=hU4bkX8iSTBOuVNu"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vail Town
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN — IMAGES */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/Mdt93i6mTBU?si=hU4bkX8iSTBOuVNu"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/vail/liongate.jpg"
                alt="Vail Town Video"
              />
            </a>

            <a
              href="https://youtu.be/rj9Xp1-ygTA?si=ohZGszJHMpNdGUFp"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/vail/viw.jpg"
                alt="Vail During Winter Video"
              />
            </a>

            <img src="/images/usa/colorado/vail/vailtown1.jpg" alt="Vail Town" />
            <img src="/images/usa/colorado/vail/vailtown2.jpg" alt="Vail Town" />
            <img src="/images/usa/colorado/vail/vailtown3.jpg" alt="Vail Town" />
            <img src="/images/usa/colorado/vail/vt.jpg" alt="Vail Town" />
            <img src="/images/usa/colorado/vail/vailtown5.jpg" alt="Vail Town" />
            <img src="/images/usa/colorado/vail/lanvelot.jpg" alt="Vail Town" />
            <img src="/images/usa/colorado/vail/esculturas.jpg" alt="Sculptures" />
            <img src="/images/usa/colorado/vail/beautifulhouse.jpg" alt="Beautiful House" />
            <img src="/images/usa/colorado/vail/ft.jpg" alt="Fantasy Town" />
            <img src="/images/usa/colorado/vail/fts.jpg" alt="Fantasy Town" />
            <img src="/images/usa/colorado/vail/mvt.jpg" alt="Vail Town" />
            <img src="/images/usa/colorado/vail/gondola.jpg" alt="Gondola Section" />
            <img src="/images/usa/colorado/vail/fallseason.jpg" alt="Fall Season" />
            <img src="/images/usa/colorado/vail/archintown.jpg" alt="Arch Structure" />
            <img src="/images/usa/colorado/vail/thestreet.jpg" alt="The Street" />
            <img src="/images/usa/colorado/vail/gsect.jpg" alt="Gondola Section" />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
